import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";

import Navbar from "../../../../components/NavbarServices";

import fabric from "../../../../images/services/ServicesPage/fabric.png";
import bore from "../../../../images/services/ServicesPage/bore.png";
import elevator from "../../../../images/services/ServicesPage/elevator.png";

import S7 from "../../../../sections/S7_Message";
import S8 from "../../../../sections/S8_Footer";

const Twolinks = styled.div`
  padding-bottom: 70px;
`;
const Wrapper = styled.div`
  padding-top: 70px;
  padding-bottom: 80px;
`;

const index = () => {
  return (
    <div>
      <Navbar>Gallery</Navbar>
      <Container maxWidth="xl">
        <Wrapper>
          <Twolinks>
            <a style={{ textDecoration: "underline" }} href="/gallery">
              videos
            </a>
            &nbsp;&nbsp;/&nbsp;&nbsp;
            <a style={{ textDecoration: "underline" }} href="#">
              images{" "}
            </a>{" "}
          </Twolinks>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <img className="img-fluid" src={elevator} />
            </Grid>
            <Grid item xs={12} md={4}>
              <img className="img-fluid" src={bore} />
            </Grid>
            <Grid item xs={12} md={4}>
              <img className="img-fluid" src={fabric} />
            </Grid>
          </Grid>
        </Wrapper>
      </Container>
      <S7 />
      <S8 />
    </div>
  );
};

export default index;
